import { render, staticRenderFns } from "./user-layout.vue?vue&type=template&id=e033469c"
import script from "./user-layout.vue?vue&type=script&lang=ts"
export * from "./user-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports